import { useMutation, useQueryClient } from '@tanstack/react-query';
import { handleUserMutationError } from '@/features/users/services/userErrorHandler';
import { deleteDealer } from '../services/dealers';
import { dealerKeys } from './useDealersQuery';

export const useDeleteDealerMutation = () => {
    const queryClient = useQueryClient();

    return useMutation<void, Error, string>({
        mutationFn: (id) => deleteDealer(id),
        onSuccess: (_, id) => {
            queryClient.invalidateQueries({ queryKey: dealerKeys.lists() });
            queryClient.removeQueries({ queryKey: dealerKeys.detail(id) });
        },
        onError: (error) => handleUserMutationError(error),
    });
};
